import { Chip } from "@mui/material";

interface Props {
  isQuotesOnly: boolean;
}

export function QuotesOnlyShipmentBadge(props: Props) {
  const { isQuotesOnly } = props;

  if (!isQuotesOnly) {
    return <div />;
  }

  return (
    <Chip
      label="QUOTES ONLY"
      color="secondary"
      variant="outlined"
      size="small"
    />
  );
}
